(function () {
  'use strict';

  var selections = {}; // { variantId: { title, price, image } }
  var initialized = false;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    if (initialized) return;
    initialized = true;
    bindCards();
    bindBar();
  }

  function bindCards() {
    document.querySelectorAll('[data-hb-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var variantId = card.getAttribute('data-variant-id');
        if (!variantId) return;

        if (selections[variantId]) {
          delete selections[variantId];
          card.classList.remove('is-selected');
        } else {
          selections[variantId] = {
            title: card.getAttribute('data-product-title'),
            price: parseFloat(card.getAttribute('data-product-price')) || 0,
            image: card.getAttribute('data-product-image')
          };
          card.classList.add('is-selected');
        }

        renderBar();
      });
    });
  }

  function bindBar() {
    var bar = document.getElementById('hb-bar');
    var toggle = bar.querySelector('[data-hb-toggle]');
    toggle.addEventListener('click', function () {
      bar.classList.toggle('is-collapsed');
    });

    bar.querySelector('[data-hb-checkout]').addEventListener('click', checkout);
  }

  function renderBar() {
    var bar = document.getElementById('hb-bar');
    var list = bar.querySelector('[data-hb-list]');
    var countEl = bar.querySelector('[data-hb-count]');
    var totalEl = bar.querySelector('[data-hb-total]');
    var totalEl2 = bar.querySelector('[data-hb-total-2]');

    var ids = Object.keys(selections);
    var totalPrice = 0;
    list.innerHTML = '';

    ids.forEach(function (variantId) {
      var item = selections[variantId];
      totalPrice += item.price;

      var li = document.createElement('li');
      li.innerHTML =
        '<img src="' + item.image + '" alt="">' +
        '<span class="hb-bar__item-name">' + item.title + '</span>' +
        '<span>' + formatMoney(item.price) + '</span>' +
        '<button type="button" class="hb-bar__item-remove" data-remove="' + variantId + '" aria-label="Remove">&times;</button>';
      list.appendChild(li);
    });

    list.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var variantId = btn.getAttribute('data-remove');
        delete selections[variantId];
        var card = document.querySelector('[data-variant-id="' + variantId + '"]');
        if (card) card.classList.remove('is-selected');
        renderBar();
      });
    });

    countEl.textContent = ids.length + ' item' + (ids.length === 1 ? '' : 's');
    totalEl.textContent = formatMoney(totalPrice);
    totalEl2.textContent = formatMoney(totalPrice);

    bar.hidden = ids.length === 0;
    if (ids.length > 0) bar.classList.remove('is-collapsed');
  }

  function checkout() {
    var ids = Object.keys(selections);
    if (!ids.length) return;

    var bundleId = 'BYO-' + Date.now();
    var items = ids.map(function (variantId) {
      return {
        id: variantId,
        quantity: 1,
        properties: {
          'Hamper Bundle': bundleId,
          'Added via': 'Build Your Own Hamper'
        }
      };
    });

    var btn = document.querySelector('[data-hb-checkout]');
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding to cart...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showToast('Could not add hamper, please try again');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function formatMoney(amount) {
    return '₹' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function showToast(msg) {
    var toast = document.getElementById('hb-toast');
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2000);
  }
})();